import React from 'react';

 

export const GlowingButton = ({ 
  type, 
  disabled = false, 
  isSubmitting = false,
  children
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`
        w-full py-3 px-4 rounded-md
        bg-gradient-to-r from-amber-600 to-amber-400
        text-gray-900 font-medium
        shadow-lg shadow-amber-500/20
        hover:shadow-amber-500/30 hover:from-amber-500 hover:to-amber-300
        focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 focus:ring-offset-gray-900
        transition-all duration-300
        relative overflow-hidden
        group
        ${disabled ? 'opacity-80 cursor-not-allowed' : ''}
      `}
    >
      <span className="relative z-10">
        {isSubmitting ? "Sending..." : children || "Send Message"}
      </span>
      
      {/* Inner glow effect */}
      <span className="absolute inset-0 bg-gradient-to-r from-amber-400 to-amber-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
      
      {/* Outer glow effect */}
      <span className="absolute -inset-1 rounded-lg bg-gradient-to-r from-amber-600/0 via-amber-500/30 to-amber-600/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-md animate-shimmer"></span>
      
      {/* Loading spinner */}
      {isSubmitting && (
        <span className="absolute inset-0 flex items-center justify-center">
          <svg className="animate-spin h-5 w-5 text-gray-900/70" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </span>
      )}
    </button>
  );
};